export interface LoggerInterface {
  log(message: string, ...args): void
  info(message: string, ...args): void
  warning(message: string, ...args): void
  error(message: string, ...args): void
}
